



























import AbpBase from '../../lib/abpbase'
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import Util from '../../lib/util'



@Component({
})
export default class UpLoad extends AbpBase {
    @Prop({piclist:Object,default:false}) piclist:any;
    //列表变化，图片信息带出
	@Watch('uploadList')
	WatchuploadList(val: any, oldVal: any) { 
		this.$emit('on-confirm',this.uploadList)
	}
    defaultList = [
        
    ]
    imgName = ''
    visible = false
    uploadList:any = []
    files = []
    visibleSrc = ''
    loadingStatus = false

    mounted () {
        if(this.piclist.list){
            this.piclist.list.forEach((item:any) => {
                this.uploadList.push({
                    oldImgName:item.oldImgName,
                    name:Util.formatTime(item.creationTime),
                    url:XMLHTTP_BASEURL+item.imgUrl,
                    imgUrl:item.imgUrl,
                    creationTime:new Date()
                })
            });
        }
        // this.uploadList = (this.$refs.upload as any).fileList;
    }
    get Url(){
        return XMLHTTP_BASEURL;
    }
    handleView (name:any,oldImgName:any,src:any) {
        this.visibleSrc = src
        console.log(this.visibleSrc)
        this.visible = true;
    }
    handleRemove (index:any) {
        // const fileList = (this.$refs.upload as any).fileList;
        // (this.$refs.upload as any).fileList.splice(fileList.indexOf(file), 1);
        this.uploadList.splice(index, 1);
        // console.log(this.files)
    }
    handleSuccess (res:any, file:any) {
        console.log(res)
        let path = res.result.objects.imageAddress
        console.log(path)
        this.uploadList.push({
            url:this.Url+path,
            path:path,
            creationTime:new Date()
        })
        console.log(this.uploadList)
    }
    
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/upload/dialysisBeginUploadImg.vue